<div
  class="mt-10 footer-area text-center bg-white border-top-radius box-shadow"
  [class.card-bordered-theme]="themeService.isCardBorder()"
  [class.component-dark-theme]="themeService.isDark()"
  [class.card-border-radius]="themeService.isCardBorderRadius()"
>
  <p>© GAMM.</p>
</div>
